export default __webpack_public_path__ + "static/media/hht1_home_img_EP3.b0fa32c5.png";